import {
  connectionColumnDefinition,
  runStatusIconColumnDefinition,
  lastRunColumnDefinition,
} from '../columnDefinitions';

import { SPECIAL_TYPE_TOGGLE_MORE } from '../../dashboard/constants';

export default [
  {
    ...connectionColumnDefinition,
    colSpan: params => params.data.type === SPECIAL_TYPE_TOGGLE_MORE ? 3 : 1,
  },
  runStatusIconColumnDefinition,
  lastRunColumnDefinition,
];
